import Collection from '../collection';
import Config from '../config';
import DataTable from '../model/datatable';





export default Collection.extend( {

    url({/* filters, page, activeId */}) {
        return Config.url( this.endpoint, { addToken: true, addBase: false } );
	},

	endpoint: 'datatables',
	model: DataTable,
	jsonp: false,
} );


// WEBPACK FOOTER //
// ./src/js/collection/datatables.js